/*
  Final Sale line item property.
  Each product form carries a hidden input  properties[Sale] = "Final Sale"
  listing the variant IDs marked FINAL SALE (data-final-sale-ids).
  This keeps that input enabled only while one of those variants is selected,
  so the note is sent to the cart (and on to checkout and the order) only for
  final-sale variants. Works for the product page, sticky bar and quick view.
*/
(function () {
  if (window.__finalSaleProperty) return;
  window.__finalSaleProperty = true;

  function sync() {
    var inputs = document.querySelectorAll('input[data-final-sale-property]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var form = input.form;
      if (!form) continue;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput) continue;
      var ids = (input.getAttribute('data-final-sale-ids') || '').split(',');
      input.disabled = ids.indexOf(String(idInput.value)) === -1;
    }
  }

  function syncSoon() {
    sync();
    setTimeout(sync, 0);
    setTimeout(sync, 250);
  }

  // Variant changes (swatches, size buttons, dropdowns)
  document.addEventListener('change', syncSoon, true);
  document.addEventListener('input', syncSoon, true);
  // Right before add to cart / Buy it now
  document.addEventListener('submit', sync, true);
  document.addEventListener('click', sync, true);
  document.addEventListener('pointerdown', sync, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  // Quick view and other content loaded after the page
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && m.target && m.target.name === 'id') { sync(); return; }
      if (m.addedNodes && m.addedNodes.length) { syncSoon(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
})();
